import ActionLogListView from '../../components/ActionLogListView';

ActionLogListScreen.propTypes = {};

function ActionLogListScreen(props) {
    return (
        <div className="container-fluid px-4 my-4">
            <ActionLogListView showFullUI={true} />
        </div>
    );
}

export default ActionLogListScreen;
